import React, { Component } from "react";
import styled, { keyframes } from "styled-components";

class Footer extends Component {
  render() {
    return (
      <Container padding={this.props.padding}>
        <Wrapper>
          <Loader leftAlign={this.props.leftAlign} size={this.props.size} />
        </Wrapper>
      </Container>
    );
  }
}

const Container = styled.div`
  display: flex;
  height: 100%;
  justify-items: center;
  vertical-align: center;
  padding: ${props => props.padding || "0"};
`;

const Wrapper = styled.div`
  flex: 1;
  height: fit-content;
`;

const rotate360 = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

const Loader = styled.div`
  border: 2px solid #ffffff;
  display: block;
  margin: ${props => (props.leftAlign ? "0 0 10px 10px" : " 0 auto")};
  border-radius: 50%;
  border-top: 2px solid #444444;
  width: ${props => props.size || "20px"};
  height: ${props => props.size || "20px"};
  animation: ${rotate360} 1s linear infinite;
`;

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Loader.js